import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-cfop-edit',
  templateUrl: './cfop-edit.component.html',
  standalone: false
})
export class CfopEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/cfops`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Cfops', link: '/cfops' }, { label: 'Edição Cfops' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'cfops',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("cfops").subscribe((data) => {
        this.fields = data;
    });
  }

}
